const options = {
  none: "pointer-events-none",
  auto: "pointer-events-auto",
};

export default function getPointerEvent(pointer) {
  return options[pointer];
}
